import { render, staticRenderFns } from "./TifOperacionesIndex.vue?vue&type=template&id=d012f5e2"
import script from "./TifOperacionesIndex.vue?vue&type=script&lang=js"
export * from "./TifOperacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports